// Resolves an image reference to a displayable URL.
// Absolute URLs (http/data/blob) are used as-is; backend-relative paths get the API host prefix.
export const mediaUrl = (u) => {
  if (!u) return u;
  if (/^(https?:|data:|blob:)/i.test(u)) return u;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  return u.startsWith("/") ? base + u : u;
};
